import React, { useMemo } from "react";
import CommonDialog from "../CommonDialog";
import { DialogContent, Typography, useMediaQuery } from "@mui/material";
import CommonTable1 from "app/components/Tables/CommonTable1";

const ViewOldStopsDialog = ({
  open = false,
  onClose = () => {},
  oldStopListData = {},
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const columns = useMemo(() => {
    return [
      {
        header: "Sr.No",
        Cell: ({ cell }) => (
          <Typography>
            {parseInt(cell?.row?.id) + 1 < 10
              ? `0${parseInt(cell?.row?.id) + 1}`
              : parseInt(cell?.row?.id) + 1}
          </Typography>
        ),
        maxSize: isMobile ? 15 : 20,
      },
      {
        header: "Stop Name",
        accessorKey: "stopName",
        Cell: ({ cell }) => (
          <Typography>{cell?.row?.original?.stopName ?? "--"}</Typography>
        ),
        size: isMobile ? 40 : 60,
      },
      {
        header: "Distance (KM)",
        accessorKey: "distance",
        Cell: ({ cell }) => (
          <Typography>{cell?.row?.original?.distance ?? "--"}</Typography>
        ),
        size: isMobile ? 25 : 30,
      },
    ];
  }, [isMobile]);

  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      title={`Old Stops - ${oldStopListData?.routeName || "Route"} (${
        oldStopListData?.routeNumber || "--"
      })`}
      minWidth={isMobile ? "95%" : "600px"}
    >
      <DialogContent>
        {oldStopListData?.oldStopList &&
        oldStopListData.oldStopList.length > 0 ? (
          <CommonTable1
            columns={columns}
            data={oldStopListData.oldStopList}
            maxHeight="400px"
          />
        ) : (
          <Typography
            sx={{
              textAlign: "center",
              py: 4,
              color: "text.secondary",
              fontStyle: "italic",
            }}
          >
            No old stops data available
          </Typography>
        )}
      </DialogContent>
    </CommonDialog>
  );
};

export default ViewOldStopsDialog;
